import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getAllAreas = (token, restaurant, organizationIdFromClient, log) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "areas/getall?restaurantid=" +
    restaurant +
    "&organizationId=" +
    organizationId +
    "&log=" +
    log;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const filterAreasTurnOverRequest = (
  token,
  filteredAreaIds,
  startDate,
  endDate
) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "areas/getturnover?&areaids=" +
    filteredAreaIds.join("&areaids=") +
    "&startDate=" +
    startDate +
    "&endDate=" +
    endDate +
    "&organizationId=" +
    organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export { getAllAreas, filterAreasTurnOverRequest };
